<template>
  <AppTypeAhead
    v-model="supplierName"
    name="subcontractor_id"
    :suggestion-callback="getSuggestions"
    :initial-suggestions="getSuggestions"
    class="form-input py-1"
    @value-selected="selectSupplier"
  />
</template>

<script setup lang="ts">
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import Package from '@/models/Package';
import { SupplierType } from '@/models/ProjectSupplier';
import { usePackagesStore } from '@/store/packages';
import { useProjectsStore } from '@/store/projects';
import { useSuppliersStore } from '@/store/supplier';
import Swal from 'sweetalert2';
import { nextTick, ref } from 'vue';

const props = defineProps<{
  package: Package;
}>();

const supplierName = ref('');
const suppliersStore = useSuppliersStore();
const projectsStore = useProjectsStore();
const packagesStore = usePackagesStore();
const suggestedSuppliers = ref<{ id: number; name: string }[]>([]);

const getSuggestions = async () => {
  suggestedSuppliers.value = await suppliersStore
    .search({
      name: supplierName.value,
      project_id: projectsStore.project.id,
      type: [SupplierType.subcontractor],
    });

  return suggestedSuppliers.value.map((value) => value.name);
};

const updatePackageAction = useStoreApiAction(packagesStore.update);

const selectSupplier = (index: number) => {
  nextTick(() => {
    if(suggestedSuppliers.value[index].id) {
      updatePackageAction.request(props.package.id, { subcontractor_id: suggestedSuppliers.value[index].id }).catch(
        (error) => {
          if(error?.status === 422 || error?.status === 403) {
            Swal.fire({
              icon: 'error',
              text: error?.data?.message,
            });
          }
        },
      );
    }
  });
};
</script>

<style scoped></style>
